import L from 'leaflet'

export class WeatherPlayBack {
  options: {
    container: any
    playSpeed: number
    playCallBack?: (...params: any) => void
    clearLayer?: (...params: any) => void
    close?: (...params: any) => void
    data: any[]
  }
  hash: Record<string, any>
  playSate: boolean
  currentTimePosition: number
  playSpeed: number
  minTime: number
  maxTime: number
  playItems: Record<string, any>
  frequency: number
  _timer_move: any
  areaLayer: any
  area_arr: undefined
  // 新增属性
  playerOptionDiv!: HTMLDivElement
  playBtn!: HTMLInputElement
  playerTiao!: HTMLDivElement
  playerYuan!: HTMLDivElement
  playerJindu!: HTMLDivElement
  playerCloseDiv!: HTMLDivElement
  playerCloseImg!: HTMLElement
  playerTiaoW!: number
  playerPercentage!: number
  playerMinValue!: number
  playerMaxValue!: number
  isMousedown!: boolean
  playerDiv!: HTMLElement
  clientX: any

  constructor(opts: any) {
    this.options = {
      container: '',
      playSpeed: 60,
      data: [],
    }
    this.hash = {}
    this.playSate = false
    this.currentTimePosition = 0
    this.playSpeed = 60
    this.minTime = 0
    this.maxTime = 0
    this.playItems = {}
    this.frequency = 1
    this._timer_move = undefined
    this.areaLayer = undefined
    this.area_arr = undefined
    if (opts) {
      L.Util.extend(this.options, opts)
    }
    this.setTimeRange()
    this.playSate = false
    this._createPlayerHtml()
    this.initPlayItem()
    return this
  }

  setTimeRange() {
    let minTime = 0
    let maxTime = 0
    this.options.data.forEach((item, i) => {
      this.hash[item.playtime] = item
      if (i == 0) minTime = item.playtime
      if (i == this.options.data.length - 1) maxTime = item.playtime
    })
    this.minTime = minTime
    this.maxTime = maxTime
    this.currentTimePosition = this.minTime
  }
  initPlayItem() {
    this._resetMinMaxTime()
    this.setPlayerDisplay()
    this.playStart(0, false, true)
    this.options.clearLayer && this.options.clearLayer()
  }
  removeAll() {
    this.currentTimePosition = 0
    this.playStop()
    this.areaLayer && this.areaLayer.remove()
    L.DomUtil.remove(this.playerDiv)
  }

  /**
   *
   *
   * @param {number} explicitTime 播放到的具体时间点
   * @param {boolean} isImmediate 控制是否立即播放
   * @param {boolean} skipCheck 是否跳过初始化设置
   * @memberof WeatherPlayBack
   */
  playStart(explicitTime = 0, isImmediate = false, skipCheck = false) {
    // 如果跳过检查参数为真，则直接返回。
    if (skipCheck) {
      return
    }

    // 定义当前时间位置的变量
    let currentTime = this.currentTimePosition

    // 如果提供了明确的时间（explicitTime），则使用该时间，并确保其在最小和最大时间范围内。
    if (explicitTime != null) {
      currentTime = Math.max(this.minTime, explicitTime)
      currentTime = Math.min(currentTime, this.maxTime)
    } else {
      // 如果没有提供明确的时间，则调整当前时间位置，确保其在有效范围内。
      currentTime = Math.max(currentTime, this.minTime)
      currentTime = Math.min(currentTime, this.maxTime)
    }

    // 更新currentTimePosition状态
    this.currentTimePosition = currentTime

    // 如果当前时间位置超出最大时间，则循环回到最小时间。
    if (this.currentTimePosition >= this.maxTime) {
      this.currentTimePosition = this.minTime
    }

    // 如果当前时间位置低于最小时间，则循环回到最大时间。
    if (this.currentTimePosition <= this.minTime) {
      this.currentTimePosition = this.minTime
    }

    // 如果立即播放参数（isImmediate）未定义，则默认为false。
    isImmediate = isImmediate == null ? false : isImmediate

    // 如果播放状态为停止（0），则根据当前时间位置开始播放。
    if (!this.playSate) {
      this.playSate = true // 设置播放状态为播放中
      this._setPlayBtnClass() // 更新播放按钮的类
      this._playByPosition(isImmediate) // 根据当前位置开始播放
    }
  }
  playStop() {
    this.playSate = !1
    this._setPlayBtnClass()
  }
  playStartOrStop() {
    // 检查播放状态
    if (this.playSate) {
      // 如果当前正在播放，调用 playStop 方法停止播放
      return this.playStop()
    } else {
      // 如果当前没有播放，首先初始化播放项
      this.initPlayItem()

      // 设置一个定时器，在一定延迟后开始播放
      // 使用 this.frequency 乘以 1000 来获取延迟的时间（单位：毫秒）
      setTimeout(() => {
        this.playStart()
      }, 1000 * this.frequency)
    }
  }
  _playByPosition(isImmediate = false) {
    // 如果播放状态为活动状态
    if (this.playSate) {
      // 如果当前时间位置小于最大时间，则执行以下操作

      if (this.currentTimePosition < this.maxTime) {
        // 如果需要立即更新时间位置，并且当前时间位置不为0，则更新
        if (!isImmediate) {
          this.currentTimePosition = this.getcurrentTime()
        }

        // 如果当前时间位置大于等于最大时间，则重置为最大时间

        this.currentTimePosition = Math.min(
          this.currentTimePosition,
          this.maxTime
        )
        // 设置播放器的位置
        this._setPlayerPosition()

        // 如果存在回调函数，则调用它
        if (this.options.playCallBack) {
          this.options.playCallBack(this.currentTimePosition)
        }

        // 如果播放状态仍然为活动状态，并且isImmediate参数为0，则设置定时器继续播放
        if (this.playSate && !isImmediate) {
          setTimeout(() => {
            this._playByPosition()
          }, 1000 * this.frequency)
        } else {
          // 否则，停止播放，更新播放按钮状态
          this.playSate = false
          this._setPlayBtnClass()
        }
      } else {
        // 如果播放完成，记录日志，停止播放，更新播放按钮状态，并设置当前时间位置为最大时间
        console.log('播放完成!')
        // 更新播放状态和播放按钮类
        this.playSate = false
        this._setPlayBtnClass()
        // 设置当前播放时间为最大时间并更新播放器位置
        this.currentTimePosition = this.maxTime
        this._setPlayerPosition()

        // 如果存在回调函数，则调用它
        if (this.options.playCallBack) {
          this.options.playCallBack(this.currentTimePosition)
        }
      }
    }
  }
  getcurrentTime() {
    let lastIndex = 0
    const playbackData = this.options.data
    for (const [i, playbackDatum] of playbackData.entries()) {
      const currentPlayTime = playbackDatum.playtime
      if (currentPlayTime > this.currentTimePosition) {
        lastIndex = i
        break
      }
    }

    return playbackData[lastIndex].playtime || playbackData[0].playtime
  }
  _resetMinMaxTime() {
    0 == this.minTime || 0 == this.maxTime
      ? (this.currentTimePosition = this.minTime)
      : this.currentTimePosition < this.minTime &&
        (this.currentTimePosition = this.minTime)
  }
  _createPlayerHtml() {
    // 创建播放器容器并添加到选项中指定的容器
    this.playerDiv = L.DomUtil.create(
      'div',
      'castboxplayer areaplayer',
      this.options.container
    )
    L.DomEvent.disableClickPropagation(this.playerDiv) // 阻止点击事件冒泡

    // 创建播放器操作区
    this.playerOptionDiv = L.DomUtil.create(
      'div',
      'areaplayer-option',
      this.playerDiv
    )

    // 创建播放按钮并设置其样式
    this.playBtn = L.DomUtil.create(
      'input',
      'areaplayer-play start float-left',
      this.playerOptionDiv
    )
    this.playBtn.type = 'button' // 明确按钮类型为按钮

    // 创建播放器轨道和手柄
    this.playerTiao = L.DomUtil.create('div', 'areaplayer-tiao', this.playerDiv)
    this.playerYuan = L.DomUtil.create(
      'div',
      'areaplayer-yuan',
      this.playerTiao
    ) // 轨道手柄
    this.playerJindu = L.DomUtil.create(
      'div',
      'areaplayer-jindu',
      this.playerTiao
    ) // 轨道进度条

    // 创建播放器关闭按钮
    this.playerCloseDiv = L.DomUtil.create(
      'div',
      'areaplayer-close',
      this.playerDiv
    )
    this.playerCloseImg = L.DomUtil.create('Img', '', this.playerCloseDiv)
    this.playerCloseImg.setAttribute(
      'src',
      'https://cdn.xplusship.com/img/images/white_close_btn.png'
    ) // 设置关闭按钮图片

    // 计算轨道的宽度
    this.playerTiaoW = this.playerTiao.offsetWidth - this.playerYuan.offsetWidth

    // 初始化播放器状态变量
    this.playerPercentage = 0
    this.playerMinValue = 0
    this.playerMaxValue = 100

    // 构建播放器的交互逻辑
    this._buildPlayer()
  }
  _setPlayBtnClass(isPlaying?: boolean) {
    // 移除现有的开始和停止类
    L.DomUtil.removeClass(this.playBtn, 'start')
    L.DomUtil.removeClass(this.playBtn, 'stop')

    // 如果isPlaying参数不是null，则更新播放状态
    if (isPlaying) {
      this.playSate = isPlaying
    }

    // 根据播放状态添加相应的类
    if (this.playSate) {
      // 如果播放状态为真，则添加停止类的样式
      L.DomUtil.addClass(this.playBtn, 'stop')
    } else {
      // 否则，添加开始类的样式
      L.DomUtil.addClass(this.playBtn, 'start')
    }
  }
  _buildPlayer() {
    const body = document.body // 更清晰的变量名

    // 初始化 mousedown 状态为 false
    this.isMousedown = false

    // 为播放按钮添加点击事件处理器
    this.playBtn.onclick = () => {
      this.playStartOrStop()
    }

    // 为 playerYuan 添加 mousedown 事件处理器
    this.playerYuan.onmousedown = () => {
      this.isMousedown = true
      // 为 document.body 添加 mousemove 事件处理器
      body.onmousemove = (event) => {
        this._setYuanPosition(event)
      }
    }

    // 为 document.body 添加 mouseup 事件处理器
    body.onmouseup = () => {
      this.isMousedown = false
      // 清除 mousemove 事件处理器
      body.onmousemove = null
    }

    // 为 playerTiao 添加 click 事件处理器
    this.playerTiao.onclick = (event) => {
      this.isMousedown = true
      this._setYuanPosition(event)
      this.isMousedown = false
    }

    // 为 playerCloseDiv 添加 click 事件处理器
    this.playerCloseDiv.onclick = () => {
      // 隐藏播放器容器
      this.options.container.style.display = 'none'
      // 如果提供了关闭回调函数，则执行它
      if (this.options.close) {
        this.options.close()
      }
    }
  }
  _setYuanPosition(event: MouseEvent) {
    // 如果鼠标按钮未被按下（即没有进行拖动操作），则不执行任何操作
    if (!this.isMousedown) {
      return
    }

    // 停止当前的播放
    this.playStop()

    // 清除任何存在的定时器
    if (this._timer_move) {
      clearTimeout(this._timer_move)
    }

    // 计算手柄的当前位置和宽度
    // const handleCurrentLeft = this.playerYuan.offsetLeft
    const handleWidth = this.playerYuan.offsetWidth

    // 计算轨道的总宽度以及手柄中心点的偏移量
    const trackWidth = this.playerTiaoW + Math.round(handleWidth / 2)

    // 计算鼠标相对于播放器控件的位置
    const mouseOffset =
      event.clientX -
      this.playerDiv.offsetLeft -
      this.playerTiao.offsetLeft -
      Math.round(handleWidth / 2)

    // 计算手柄新的水平位置偏移量，并限制在轨道宽度内
    const newHandleLeft = Math.min(trackWidth, Math.max(0, mouseOffset))

    // 更新手柄的样式位置
    this.playerYuan.style.marginLeft = `${newHandleLeft}px`

    // 更新进度条的宽度
    this.playerJindu.style.width = `${newHandleLeft}px`

    // 计算新的播放时间百分比
    this.playerPercentage =
      Math.round((newHandleLeft / trackWidth) * 10000) / 10000

    // 计算新的播放时间点
    const newTime =
      this.minTime +
      Math.round(this.playerPercentage * (this.maxTime - this.minTime))

    // 将时间转换为分钟，并保留整数分钟
    const timeInMinutes = 60 * Math.round(newTime / 60)

    // 设置一个新的定时器，以更新播放位置
    this._timer_move = setTimeout(() => {
      this.playStart(timeInMinutes, true)
    }, 500)
  }
  _setPlayerPosition() {
    // 计算当前时间位置相对于最小时间的偏移量，并确保其不小于0
    const timeOffset = Math.max(0, this.currentTimePosition - this.minTime)

    // 设置播放器的最小和最大值
    this.playerMinValue = 0
    this.playerMaxValue = Math.max(0, this.maxTime - this.minTime)

    // 如果当前时间位置等于最大时间，则暂停播放，并更新播放按钮的状态
    if (this.currentTimePosition === this.maxTime) {
      this._setPlayBtnClass(false)
    }

    // 计算当前时间位置的百分比，并四舍五入到小数点后四位
    this.playerPercentage =
      Math.round((timeOffset / this.playerMaxValue) * 1e4) / 1e4

    // 获取播放器手柄的宽度
    const handleWidth = this.playerYuan.offsetWidth
    // 计算轨道的可用宽度
    this.playerTiaoW = this.playerTiao.offsetWidth - handleWidth

    // 计算手柄的新位置，并确保百分比在0到1之间
    const trackWidth = this.playerTiaoW + Math.round(handleWidth / 2)
    this.playerPercentage = Math.max(0, Math.min(this.playerPercentage, 1))

    // 计算手柄偏移量，并更新手柄和进度条的样式
    const handleOffset = this.playerPercentage * trackWidth
    this.playerYuan.style.marginLeft = `${handleOffset}px`
    this.playerJindu.style.width = `${handleOffset}px`
  }
  // 如果 shouldDisplay 未定义，则根据时间范围是否有效来决定
  setPlayerDisplay(shouldDisplay = this.maxTime - this.minTime > 0) {
    // 移除隐藏和显示的类，以便根据条件重新设置
    L.DomUtil.removeClass(this.playerDiv, 'areaplayer-display-none')
    L.DomUtil.removeClass(this.playerDiv, 'areaplayer-display-block')

    if (shouldDisplay) {
      // 如果应该显示播放器控件
      L.DomUtil.addClass(this.playerDiv, 'areaplayer-display-block') // 添加显示类的样式
      this.playerTiaoW =
        this.playerTiao.offsetWidth - this.playerYuan.offsetWidth // 计算轨道宽度
      this.playStart(0, true) // 开始播放
    } else {
      // 如果不应该显示播放器控件
      L.DomUtil.addClass(this.playerDiv, 'areaplayer-display-none') // 添加隐藏类的样式
    }
  }
}

// 使用 WeatherPlayBack 类
// const weatherPlayBack = new WeatherPlayBack({
//   container: '#containerId',
//   playSpeed: 60,
//   playCallBack: (time) => console.log('Playing at time:', time),
//   data: []
// })
